import { PortalHost } from '@gorhom/portal';
import { createContext, ReactNode, useState } from 'react';
import { KeyboardAvoidingView, View } from 'react-native';
import { useKeyboardVisibility } from '../TextInput/KeyboardOverlay/useKeyboardVisibility';

export const KeyboardOffsetContext = createContext({
  offset: 0,
});

export function KeyboardOffsetProvider({ children }: { children: ReactNode }) {
  const [offset, setOffset] = useState(0);
  const keyboardVisible = useKeyboardVisibility();

  return (
    <KeyboardOffsetContext.Provider value={{ offset }}>
      {children}
      <KeyboardAvoidingView behavior="position">
        <View
          onLayout={ev => {
            setOffset(ev.nativeEvent.layout.height);
          }}
        >
          {keyboardVisible && <PortalHost name="KeyboardAccessory" />}
        </View>
      </KeyboardAvoidingView>
    </KeyboardOffsetContext.Provider>
  );
}
